import script from "./BaseAudioElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseAudioElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseAudioElement.vue?vue&type=style&index=0&id=5da834d7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da834d7"]])

export default __exports__